import React, { useState, useEffect } from 'react';
import { replaceValues, getInfo } from '../../utils/api';
import { toast } from 'sonner';
import { useT } from '../../i18n';

const ReplaceOperation = ({ onSuccess, onCancel }) => {
  const t = useT();
  const [column, setColumn] = useState('');
  const [findValue, setFindValue] = useState('');
  const [replaceValue, setReplaceValue] = useState('');
  const [caseSensitive, setCaseSensitive] = useState(false);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadColumns = async () => {
      try {
        const result = await getInfo();
        const cols = result.info.column_names || [];
        setColumns(cols);
        if (cols.length > 0) {
          setColumn(cols[0]);
        }
      } catch (error) {
        toast.error(t('form.loadColumnsFailed'));
      }
    };
    loadColumns();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await replaceValues({
        column,
        find_value: findValue,
        replace_value: replaceValue,
        case_sensitive: caseSensitive
      });
      onSuccess(result);
    } catch (error) {
      toast.error(error.response?.data?.detail || t('replace.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="label mb-1">{t('form.column')}</label>
        <select value={column} onChange={(e) => setColumn(e.target.value)} className="select" required>
          {columns.map(col => (
            <option key={col} value={col}>{col}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="label mb-1">{t('replace.findLabel')}</label>
        <input
          type="text"
          value={findValue}
          onChange={(e) => setFindValue(e.target.value)}
          className="input"
          placeholder={t('replace.findPlaceholder')}
          required
        />
      </div>

      <div>
        <label className="label mb-1">{t('replace.withLabel')}</label>
        <input
          type="text"
          value={replaceValue}
          onChange={(e) => setReplaceValue(e.target.value)}
          className="input"
          placeholder={t('replace.withPlaceholder')}
          required
        />
      </div>

      <div>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={caseSensitive}
            onChange={(e) => setCaseSensitive(e.target.checked)}
            className="h-4 w-4"
          />
          <span className="text-sm">{t('replace.caseSensitive')}</span>
        </label>
      </div>

      <div className="flex gap-2 pt-4 border-t">
        <button type="submit" disabled={loading} className="btn-primary flex-1" data-testid="apply-replace">
          {loading ? t('replace.replacing') : t('replace.apply')}
        </button>
        <button type="button" onClick={onCancel} className="btn-secondary">
          {t('form.cancel')}
        </button>
      </div>
    </form>
  );
};

export default ReplaceOperation;